module.exports = __webpack_public_path__ + "img/57.681712f9.png";